import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";

import { BaseDialog, CircularProgress, Error } from "payu-ui/v2";
import { toggleMerchantSession } from "dashboard-utils";
import { MERCHANT_SESSION } from "dashboard-utils/lib/constants/env";
import { fetchUATMID } from "../services/api/merchant_info";
import { COOKIES_KEYS } from "../constants/global";

const SwitchModes = ({ setShowSwitchModeModal, merchantInfo, setMerchantSession }) => {
    const [modalContent, setModalContent] = useState('LOADING');

    const fetchMID = async () => {
        setModalContent('LOADING');
        try {
            const cookies = new Cookies();
            const { data: { status, result: { token_data, uat_product_account } } } = await fetchUATMID({ uuid: cookies.get(COOKIES_KEYS.PRODUCT_ACCOUNT_UUID), product: cookies.get(COOKIES_KEYS.PRODUCT), email: merchantInfo.email });
            if(status == '200') {
                cookies.set(COOKIES_KEYS.TEST_AUTH_TOKEN, token_data.access_token);
                cookies.set(COOKIES_KEYS.TEST_MERCHANT_MID, uat_product_account.identifier);
                cookies.set(COOKIES_KEYS.TEST_PRODUCT_ACCOUNT_UUID, uat_product_account.uuid);
                cookies.set(COOKIES_KEYS.TEST_MERCHANT_ACCOUNT_UUID, uat_product_account.merchant_account_uuid);
                setShowSwitchModeModal(false);
                setMerchantSession(MERCHANT_SESSION.TEST);
                toggleMerchantSession(MERCHANT_SESSION.TEST);
            } else {
                setModalContent('ERROR_SCREEN');
            }
        } catch (error) {
            setModalContent('ERROR_SCREEN');
        }
    }

    const modalData = {
        'LOADING':  {
            content: <CircularProgress color="DEFAULT" />
        },
        'ERROR_SCREEN': {
            content: <Error
                actions={[
                    {
                        onClick: () => { fetchMID() },
                        size: 'medium',
                        text: 'Retry',
                        variant: 'PRIMARY'
                    },
                    {
                        onClick: () => { setShowSwitchModeModal(false) },
                        size: 'medium',
                        text: 'Back to Live Mode',
                        variant: 'SECONDARY'
                    }
                ]}
                description={{
                    props: {
                        className: 'tw-text-green-gray-300',
                        variant: 'P2',
                        weight: 'medium'
                    },
                    text: 'You may retry the action.'
                }}
                heading={{
                    props: {
                        className: 'tw-text-gray-900',
                        variant: 'H3',
                        weight: 'semi-bold'
                    },
                    text: 'Facing some technical issue'
                }}
                imageProps={{
                    className: 'tw-bg-blue-50 tw-py-[40px] tw-px-[40px]',
                    height: '148px',
                    type: 'server-error',
                    width: '148px'
                }}
                message={{
                    props: {
                        className: 'tw-text-green-gray-300',
                        variant: 'SH3',
                        weight: 'medium'
                    },
                    text: 'Unable to load test Mode'
                }}
                className=''
            />
        }
    }

    useEffect(() => {
        fetchMID();
    }, []);

    return (
        <BaseDialog open={true} width="md" showCloseIcon={false} className={modalContent ==='LOADING'? 'transparent': 'p-16'}>
            {modalData[modalContent].content}
        </BaseDialog>
    );
};

export default SwitchModes;